<button type="button" class="picker-button" [matMenuTriggerFor]="menu">
  <mat-icon class="icon">dark_mode</mat-icon>
</button>

<mat-menu class="compact-menu" #menu="matMenu">
  <button mat-menu-item (click)="pickScheme(ColorScheme.Dark)">
    <div class="menu-item">
      <div class="selected-indicator" [class.show]="currentScheme === ColorScheme.Dark"></div>
      <div class="scheme-icon" dark="true"></div>
      <div trans="theme.picker.dark" class="label"></div>
    </div>
  </button>
  <button mat-menu-item (click)="pickScheme(ColorScheme.Light)">
    <div class="menu-item">
      <div class="selected-indicator" [class.show]="currentScheme === ColorScheme.Light"></div>
      <div class="scheme-icon" dark="false"></div>
      <div trans="theme.picker.light" class="label"></div>
    </div>
  </button>
  <button mat-menu-item (click)="pickScheme(null)">
    <div class="menu-item">
      <div class="selected-indicator" [class.show]="currentScheme === null" ></div>
      <div class="scheme-icon-mixer">
        <div class="scheme-icon" dark="false"></div>
        <div class="scheme-icon" dark="true"></div>
      </div>
      <div trans="theme.picker.system" class="label"></div>
    </div>
  </button>
</mat-menu>
